module.exports = __webpack_public_path__ + "static/media/main idea.54a6d002.mp3";